export const ACTION_RESET = 'FETCH_EVENTLIST_RESET';
export const ACTION_REQUEST = 'FETCH_EVENTLIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_EVENTLIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_EVENTLIST_ERROR';